// import { createClient } from 'contentful';
// import Cookies from 'js-cookie';
// import axios from 'axios';

// const contentfulClient = createClient({
//   space: Cookies.get('contentfulSpaceId'),
//   accessToken: Cookies.get('contentfulCdaKey'),
//   environment: Cookies.get('contentFulEnvironment'),
// });

// // Cache for feature flag to avoid multiple API calls
// let useBackendForStoreCategories = null;
// let featureFlagPromise = null;

// // Check feature flag API to determine data source
// const checkFeatureFlag = async () => {
//   if (featureFlagPromise) {
//     return featureFlagPromise;
//   }
  
//   featureFlagPromise = new Promise((resolve, reject) => {
//     axios
//       .get(`${Cookies.get("apiEnv")}/contentful_data/available`)
//       .then(response => {
//         const data = response.data;
//       // const shouldUseBackend = false;
//       const shouldUseBackend = data === true ||  data === 'true' || (typeof data === 'object' && (data.use_backend === true || data.available === true));
//         useBackendForStoreCategories = shouldUseBackend;
//         resolve(useBackendForStoreCategories);
//       })
//       .catch(error => {
//         console.warn('Feature flag API failed', error);
//         reject(error);
//       });
//   });
  
//   return featureFlagPromise;
// };

// // Fetch all storeTemplate entries from backend and index by id
// const fetchAllTemplatesFromBackend = async () => {
//   const response = await axios.get(`${Cookies.get('apiEnv')}/contentful_data/store_templates`);
//   const items = response.data && response.data.items ? response.data.items : (Array.isArray(response.data) ? response.data : []);
//   const idToFields = {};
//   items.forEach(entry => {
//     if (entry && entry.sys && entry.sys.id) {
//       idToFields[entry.sys.id] = entry.fields;
//     } else if (entry && entry.id && entry.fields) {
//       idToFields[entry.id] = entry.fields;
//     }
//   });
//   return idToFields;
// };

// // Override the getEntries method on the Contentful client
// const originalGetEntries = contentfulClient.getEntries.bind(contentfulClient);

// contentfulClient.getEntries = async (params) => {
//   // Only check feature flag for storeCategory content type
//   if (params.content_type === 'storeCategory') {
//     // Check feature flag first
//     const shouldUseBackend = await checkFeatureFlag();
    
//     if (shouldUseBackend) {
//       // Call your backend API for store categories
//       const response = await axios.get(`${Cookies.get('apiEnv')}/contentful_data/store_categories`);
//      // return response.data;
//       // Transform backend response to Contentful format - only transform storeTemplates
//       // If storeTemplates are Link objects, resolve them from Contentful by IDs
//       const itemsFromBackend = response.data.items || [];
//     //  return response.data;
//       const allTemplateLinkIds = [];
//       itemsFromBackend.forEach(item => {
//         const links = (item.fields && item.fields.storeTemplates) || [];
//         links.forEach(link => {
//           const id = link && link.sys && link.sys.linkType === 'Entry' ? link.sys.id : null;
//           if (id) {
//             allTemplateLinkIds.push(id);
//           }
//         });
//       });

//       let idToTemplateFields = {};
//       try {
//         // Fetch all templates once from backend and resolve locally
//         idToTemplateFields = await fetchAllTemplatesFromBackend();
//       } catch (e) {
//         console.warn('Failed to resolve storeTemplate links from backend', e);
//       }

//       const transformedResponse = {
//         ...response.data,
//         items: itemsFromBackend.map(item => {
//           const links = (item.fields && item.fields.storeTemplates) || item.storeTemplates || [];
//           const transformedTemplates = links
//             .map(link => {
//               const id = link && link.sys && link.sys.linkType === 'Entry' ? link.sys.id : null;
//               const fields = id ? idToTemplateFields[id] : null;
//               return fields ? { fields } : null;
//             })
//             .filter(Boolean);

//           return {
//             ...item,
//             fields: {
//               ...(item.fields || {}),
//               storeTemplates: transformedTemplates,
//             },
//           };
//         }),
//       };
//       console.log("transformedResponse", transformedResponse);
//       return transformedResponse;
//     } else {
     
//       // Use Contentful for store categories
//       return originalGetEntries(params);
//     }
//   }
//   if (params.content_type === 'productNews') {
//     const shouldUseBackend = await checkFeatureFlag();
//     if (shouldUseBackend) {
//       const response = await axios.get(`${Cookies.get('apiEnv')}/contentful_data/news`);
//       return response.data;
//     }
//   }
  
//   else {
//     // Use Contentful for all other content types
//     return originalGetEntries(params);
//   }
// };

// const ContentfulClient = contentfulClient;

// export default ContentfulClient;



import axios from 'axios';
import Cookies from 'js-cookie';

// Fetch all templates from backend
const fetchAllTemplatesFromBackend = async () => {
  const response = await axios.get(`${Cookies.get('apiEnv')}/contentful_data/store_templates`);
  const items = Array.isArray(response.data) ? response.data : response.data.items || [];
  const idToFields = {};
  items.forEach(entry => {
    const id = entry?.sys?.id || entry?.id;
    if (id) {
      idToFields[id] = entry.fields;
    }
  });
  return idToFields;
};

const getEntries = async (params) => {
  const type = params?.content_type;

  switch (type) {
    case 'storeCategory': {
      const response = await axios.get(`${Cookies.get('apiEnv')}/contentful_data/store_categories`);
      const items = response.data.items || [];

      // Resolve templates locally
      const idToTemplateFields = await fetchAllTemplatesFromBackend();
      const transformedItems = items.map(item => {
        const links = item.fields?.storeTemplates || [];
        const resolvedTemplates = links
          .map(link => {
            const id = link?.sys?.id;
            const fields = id ? idToTemplateFields[id] : null;
            return fields ? { fields } : null;
          })
          .filter(Boolean);

        return {
          ...item,
          fields: {
            ...item.fields,
            storeTemplates: resolvedTemplates,
          },
        };
      });

      return { ...response.data, items: transformedItems };
    }

    case 'productNews':{
    
    
      const response = await axios.get(`${Cookies.get('apiEnv')}/contentful_data/news`);
      return response.data;
    
  }

    default:
      return axios.get(`${Cookies.get('apiEnv')}/contentful_data/${type}`);
  }
};

const ContentfulClient = { getEntries };

export default ContentfulClient;
